const Top: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="flex flex-col">{children}</div>
);

export default Top;
